'use strict';

var initialized = false,
	disableMinimize = false,
	commonElements = require('./../../../app_storefront_core_UI/cartridge/js/common-elements'),
	util = require('./../../../app_storefront_core_UI/cartridge/js/util'),
	tls = require('./../../../app_storefront_core_UI/cartridge/js/tls'),
	commonHeader = require('./../../../app_storefront_core_UI/cartridge/js/header'),
	$cache = {},
	options = {
		'startMinimize': {
			'desktop': 150,
			'mobile': 150
		},
		'calcDelay': 400
	};


/**
 * @private
 * @function
 * @description Initializes parameters for component
 */
function initializeParams(params) {
	options = $.extend(true, {}, options, params);
}


/**
 * @private
 * @function
 * @description Initializes cache for component
 */
function initializeCache() {
	$cache.window = $(window);
	$cache.document = $(document);
	$cache.body = $('body');
	$cache.main = $('#main');
	$cache.header = $('.js-sticky_header');
	$cache.headerWrapper = $('.js-sticky_header-wrapper');
	$cache.utilityLinks = $('.js-utility_menu-link');
	$cache.utilityPopups = $('.js-utility_popup-item');
}


/**
 * @private
 * @function
 * @description Initializes events for component
 */
function initializeEvents() {
	commonHeader.setAssistantCookie();
	// Header utility menu
	$cache.utilityLinks.on('click touchstart', function(e) {
		e.preventDefault();
		var that = this,
			isClosed = !$(this).hasClass('active');

		closeUtilityPopups();

		if (isClosed) {
			if ($(this).data('scroll-top')) {
				util.scrollBrowser(0, 400, function() {
					$cache.body.removeClass('js-header_fixed');
					$cache.document.trigger('header.calculatelimit', {
						container: $cache.utilityPopups.filter($(that).data('utility-popup'))
					});
				});
			}
			openUtilityPopup(that); // open popup without any time delays for correct autofocusing when search icon clicked

			// for devices with iOS to display keyboard a focusing on field should be directly in function that is binded on click/touch event
			if (util.isIOS() && ($(that).data('utility-popup') == '.b-header-search')) {
				$cache.utilityPopups.filter('.b-header-search').find('#q').focus();
			}
		}
	});

	// Toggle mincart on add to cart click
	$cache.document
		.on('minicart.shown', function(event, customEvent) {
			$(customEvent.container).next('.js-utility_menu-link:not(.active)').click();
		})
		.on('minicart.hidden', function(event, customEvent) {
			$(customEvent.container).next('.js-utility_menu-link.active').click();
		});

	// Header cookie messages
	$('.js-cookies_message').each(function() {
		var that = $(this),
			cookieTTL = 60 * 24,
			cookieName = that.data('cookieName');

		if (!tls.getCookie(cookieName)) {
			that.addClass('js-showed');
			if (cookieName == 'hideCookiesAcceptance') {
				cookieTTL = 60 * 24 * 365;
				tls.setCookie(cookieName, true, cookieTTL);
			}
			that.on('click', '.js-close', function(e) {
				e.preventDefault();
				tls.setCookie(cookieName, true, cookieTTL);
				$cache.headerWrapper.height($cache.headerWrapper.outerHeight() - that.outerHeight());
				that.addClass('js-closed');
			});
		}
	});

}

// Open utility popup
function openUtilityPopup(element, disableHeader) {
	var popupSelector = $(element).data('utility-popup'),
		$popup = $cache.utilityPopups.filter(popupSelector),
		$similarLinks = $cache.utilityLinks.filter(function() {
			return $(this).data("utility-popup") == popupSelector;
		});

	commonElements.loadLazyIframes($popup);

	disableHeader && $cache.body.removeClass('js-header_fixed');
	$cache.body.removeClass('js-header_minimized').addClass('js-utility_opened');
	$similarLinks.addClass('active');
	$popup.addClass('active');

	$cache.main.on('click.utility', function() {
		closeUtilityPopups();
	});

	(popupSelector != '#mini-cart') && $popup.slideDown();

	setTimeout(function() {
		$cache.document.trigger('header.openpopup', {
			container: $popup
		});
	}, options.calcDelay);
}


// Closing all utility popups
function closeUtilityPopups() {
	var $activePopups = $cache.utilityPopups.filter('.active');
	if ($activePopups.size() > 0) {
		$activePopups.find(':focus, iframe').blur();

		$cache.utilityLinks.removeClass('active');
		$cache.utilityPopups.removeClass('active');
		$cache.body.removeClass('js-utility_opened').addClass('js-header_fixed');

		$cache.main.off('click.utility');

		!$activePopups.is('#mini-cart') && $activePopups.slideUp();

		$cache.document.trigger('header.closepopup');
	}
}

module.exports = {
	init: function(params) {
		if (initialized) {
			return;
		}
		initializeParams(params);
		initializeCache();
		initializeEvents();
		initialized = true;
	}
}
